import { type Coordenadas, urlMapa, urlMapaEmbebido } from "@/lib/terreno";

export interface MapaDireccionProps {
  direccion: string;
  /** Si están, el mapa y el link apuntan al lugar exacto en vez de buscar la dirección escrita. */
  latitud?: string | null;
  longitud?: string | null;
  /** Miniatura chica (~150 px) sin interacción: todo el bloque es un link a Google Maps. */
  miniatura?: boolean;
}

/** Mapa de Google embebido a partir de una dirección (sin clave de API) y el link para abrirlo en Google Maps. */
export function MapaDireccion({ direccion, latitud, longitud, miniatura = false }: MapaDireccionProps) {
  const coordenadas: Coordenadas | null = latitud && longitud ? { latitud, longitud } : null;
  const link = urlMapa(direccion, coordenadas);

  if (miniatura) {
    // El iframe no recibe el puntero (no se arrastra ni hace zoom); encima, un link que cubre todo el bloque.
    return (
      <div className="relative h-[150px] w-full overflow-hidden rounded-control border border-borde bg-superficie-2">
        <iframe
          title={`Mapa de ${direccion}`}
          src={urlMapaEmbebido(direccion, coordenadas, 15)}
          className="pointer-events-none h-full w-full"
          loading="lazy"
          tabIndex={-1}
          aria-hidden
          referrerPolicy="no-referrer-when-downgrade"
        />
        <a
          href={link}
          target="_blank"
          rel="noreferrer"
          aria-label={`Ver ${direccion} en Google Maps`}
          className="absolute inset-0 flex items-end justify-end p-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primario"
        >
          <span aria-hidden className="rounded-control bg-superficie/90 px-2 py-1 text-chico font-medium text-primario shadow-tarjeta">
            Abrir en Google Maps
          </span>
        </a>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <iframe
        title={`Mapa de ${direccion}`}
        src={urlMapaEmbebido(direccion, coordenadas)}
        className="h-64 w-full rounded-control border border-borde"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
      <a href={link} target="_blank" rel="noreferrer" className="self-start text-chico font-medium text-primario underline-offset-2 hover:underline">
        Abrir en Google Maps
      </a>
    </div>
  );
}
